import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class JsonUtilsService {
    parseJson(jsonPayload: string): any {
        let result: any = {};
        try {
            result = JSON.parse(jsonPayload);
        } catch (e) {
            console.error('parseJson failed to parse invalid JSON:', e);
        }
        return result;
    }
}
